var _path, _g, _ellipse, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_27",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 10,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000366211 10.6278H31V42.4541H-0.000366211V10.6278Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_27)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8211 30.1826V24.2963C26.8211 19.8067 23.7499 15.9159 19.5141 14.3196C19.726 9.33101 11.2535 9.43095 11.5714 14.3196C7.22924 15.9159 4.26431 19.8069 4.26431 24.2963V30.1826H26.8218H26.8211ZM4.15769 32.0782C0.662951 33.4749 -1.24344 38.8622 1.08647 38.8622H10.8297C11.8887 43.6511 19.0902 43.6511 20.149 38.8622H29.9982C32.3281 38.8622 30.3159 33.4746 26.8211 32.0782H4.15769ZM17.3958 13.8204C16.1249 13.6208 14.8543 13.6208 13.5834 13.8204C14.113 11.9248 16.8665 11.9248 17.3958 13.8204Z",
    fill: "black"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 5.06158,
    rx: 8,
    ry: 5.06158,
    fill: "#198754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 3.03079C29.0247 3.03079 29.9293 3.29484 30.5615 3.69485C31.1997 4.09879 31.5 4.59493 31.5 5.06204C31.4998 5.52902 31.1995 6.02445 30.5615 6.42825C29.9293 6.82827 29.0247 7.09232 28 7.09232C26.9753 7.09232 26.0707 6.82827 25.4385 6.42825C24.8005 6.02445 24.5002 5.52902 24.5 5.06204C24.5 4.59493 24.8003 4.09879 25.4385 3.69485C26.0707 3.29484 26.9753 3.03079 28 3.03079Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.aaa53eb7ccae6b24c59bfc7fc419d5fd.svg";
export { ForwardRef as ReactComponent };